export const ELEMENT_TYPE = {
  BUTTON: 'button',
  BUTTON_SUBTYPE_LINK: 'link',
  DROPDOWN: 'dropdown',
  LINK: 'link',
  INPUT: 'input',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  AUTOCOMPLETE: 'autocomplete',
  DATERANGE: 'daterange',
  TAG: 'tag',
  TEXT: 'text',
  NODE: 'node',
  KEYVALUE: 'keyvalue',
  MULTISELECT: 'multiselect',
  MIN_MAX: 'minmax',
  DATE_PICKER: 'datepicker',
};
export const errorMap = {
  400: {
    message: 'Error Found',
    description: 'Please rectify these to proceed.',
  },
  401: {
    message: 'Authorization Failed',
    description:
      "You don't have permission to view this page using the credentials you supplied. Please check it or contact your admin.",
  },
  403: {
    message: 'Forbidden',
    description:
      'We are sorry, but you do not have the permission to access this on the server. Please contact your admin.',
  },
  404: {
    message: 'Not Found',
    description: 'Request data not found',
  },
  422: {
    message: 'Error Found',
    description: 'Please rectify these to proceed.',
  },
  500: {
    message: 'Something Went Wrong',
    description:
      'An unexpected error occurred. Please try again or feel free to contact support if problem persists.',
  },
  502: {
    message: 'An Error Occurred',
    description:
      'The server encountered a temporary error and could not complete your request. Please try again in 20 seconds.',
  },
  503: {
    message: 'Service Unavailable',
    description:
      'The server is temporarily unable to service your request due to maintenance downtime or capacity problems. Please try again later.',
  },
  504: {
    message: 'An Error Occurred',
    description:
      'The server encountered a temporary error and could not complete your request. Please try again in 20 seconds.',
  },
};

export const AUTH_ERROR = {
  JWT_TOKEN_NOT_FOUND: 'JWT token not found',
};

export const GenericError = {
  ERROR: 'Some Error Occoured!!',
  ERR_USER_DETAILS_DECODE: 'Error for decodeing JWT Token',
};

export const ENV_NOT_DEFINED = 'env value not found';
export const ERR_UPLOAD_DOC_STATUS =
  'There may be some issue in uploading the document. Please reload and try again.';
export const GENERIC_ERR_OCCURED = 'Some Error occoured';
export const ERR_OCCURED_DOC_UPLOAD =
  'There may be some issue in uploading the document. Please reload or contact admin.';
export const FILED_TO_REFRESH_TOKEN =
  'There may be some issue with refresing the JWT Token';
export const FAILED_TO_GET_ONBOARDING_STATUS =
  'There may be some issue with onboarding status';
export const latlng = {
  latitude: '28.7040592',
  longitude: '77.1024901',
};

export const FINPAAS_SERVICE_ID = 10;
export const FINPAAS_SYS_SERVICE_ID = 14;

export const CREDENTIAL_URL = 'credentials/einvoice';
export const EWAY_LINK =
  'https://partnerhub.helpscoutdocs.com/article/345-how-to-register-on-e-invocice-e-way-bill-portal';

export const RESEND_OTP_TIMER_DURATION = 30;

export const LOGIN_METHOD = {
  PHONE: 'phone',
  EMAIL: 'email',
};
